export const DifficultyLevels = [
  'veryEasyQuestions',
  'easyQuestions',
  'difficultQuestions',
  'veryDifficultQuestions',
];

export const QualityLevels = [
  'badQuestions',
  'averageQuestions',
  'goodQuestions',
  'excellentQuestions',
];

export enum KeyboardArrows {
  LEFT = 'ArrowLeft',
  RIGHT = 'ArrowRight',
  UP = 'ArrowUp',
  DOWN = 'ArrowDown',
}

export enum MoveObjectOnArrowKey {
  smallStep = 5,
  bigStep = 20,
}

export enum MoveVPTOnArrowKey {
  smallStep = 20,
  bigStep = 50,
}

export const MoveKeyDownHoldTimeLimit = 250;

export enum PermissionStatus {
  ENABLED_FOR_ALL = 'ENABLED_FOR_ALL',
  PARTIAL_ENABLED = 'PARTIAL_ENABLED',
  DISABLED_FOR_ALL = 'DISABLED_FOR_ALL',
}

export const keyboardArrowsArray: string[] = [
  KeyboardArrows.LEFT,
  KeyboardArrows.RIGHT,
  KeyboardArrows.UP,
  KeyboardArrows.DOWN,
];

export const DEFAULT_OBJECT_MOVEMENT = 10;

export const Months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
